export function extractExternalLinksFromString(content: string): string[] {
  const links: string[] = [];
  const regex =
    /['"](https?:\/\/[^\/]+\/?[^'"\s]+?\.(js|css|woff|woff2|ttf|eot|otf|svg|sfnt))['"]/g;
  let match;

  while ((match = regex.exec(content)) !== null) {
    const url = match[1];

    if (!url.includes('clinch')) {
      links.push(url);
    }
  }

  return links;
}
